import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_plugin_17181562 from 'nuxt_plugin_plugin_17181562' // Source: ./components/plugin.js (mode: 'all')
import nuxt_plugin_nuxtsvgsprite_5a70aed4 from 'nuxt_plugin_nuxtsvgsprite_5a70aed4' // Source: ./nuxt-svg-sprite.js (mode: 'all')
import nuxt_plugin_axios_40b5c378 from 'nuxt_plugin_axios_40b5c378' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_deviceplugin_70ee6303 from 'nuxt_plugin_deviceplugin_70ee6303' // Source: ./device.plugin.js (mode: 'all')
import nuxt_plugin_apollomodule_78999744 from 'nuxt_plugin_apollomodule_78999744' // Source: ./apollo-module.js (mode: 'all')
import nuxt_plugin_vuescrollto_59c8eb91 from 'nuxt_plugin_vuescrollto_59c8eb91' // Source: ./vue-scrollto.js (mode: 'client')
import nuxt_plugin_lazySizes_2ffd0c20 from 'nuxt_plugin_lazySizes_2ffd0c20' // Source: ./lazySizes.js (mode: 'all')
import nuxt_plugin_rangeSlider_49b059af from 'nuxt_plugin_rangeSlider_49b059af' // Source: ../plugins/rangeSlider.js (mode: 'client')
import nuxt_plugin_pagination_0c55d867 from 'nuxt_plugin_pagination_0c55d867' // Source: ../plugins/pagination.js (mode: 'client')
import nuxt_plugin_fancyappsui_7799b51b from 'nuxt_plugin_fancyappsui_7799b51b' // Source: ../plugins/fancyapps-ui.js (mode: 'client')
import nuxt_plugin_infiniteLoading_36c8a665 from 'nuxt_plugin_infiniteLoading_36c8a665' // Source: ../plugins/infiniteLoading.js (mode: 'client')
import nuxt_plugin_numberAnim_732761f2 from 'nuxt_plugin_numberAnim_732761f2' // Source: ../plugins/numberAnim.js (mode: 'client')
import nuxt_plugin_ymaps_3e7212dd from 'nuxt_plugin_ymaps_3e7212dd' // Source: ../plugins/ymaps.js (mode: 'client')
import nuxt_plugin_swiper_68e7f06e from 'nuxt_plugin_swiper_68e7f06e' // Source: ../plugins/swiper.js (mode: 'all')
import nuxt_plugin_inputmask_6c1106f7 from 'nuxt_plugin_inputmask_6c1106f7' // Source: ../plugins/inputmask.js (mode: 'all')
import nuxt_plugin_slideToggle_24c04730 from 'nuxt_plugin_slideToggle_24c04730' // Source: ../plugins/slideToggle.js (mode: 'all')
import nuxt_plugin_lodash_5d4c7b8c from 'nuxt_plugin_lodash_5d4c7b8c' // Source: ../plugins/lodash.js (mode: 'all')
import nuxt_plugin_tippy_7d0eb109 from 'nuxt_plugin_tippy_7d0eb109' // Source: ../plugins/tippy.js (mode: 'all')
import nuxt_plugin_helpers_1c816d70 from 'nuxt_plugin_helpers_1c816d70' // Source: ../plugins/helpers.js (mode: 'all')
import nuxt_plugin_jsonld_593ee954 from 'nuxt_plugin_jsonld_593ee954' // Source: ../plugins/jsonld (mode: 'all')
import nuxt_plugin_domain_d2923006 from 'nuxt_plugin_domain_d2923006' // Source: ../plugins/domain.js (mode: 'all')
import nuxt_plugin_apiService_6b93a5b4 from 'nuxt_plugin_apiService_6b93a5b4' // Source: ../plugins/apiService.js (mode: 'all')
import nuxt_plugin_chart_48b5b2cf from 'nuxt_plugin_chart_48b5b2cf' // Source: ../plugins/chart.js (mode: 'all')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root ? this.$root.$options.$nuxt : null
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":false,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule

function registerModule (path, rawModule, options = {}) {
  const preserveState = process.client && (
    Array.isArray(path)
      ? !!path.reduce((namespacedState, path) => namespacedState && namespacedState[path], this.state)
      : path in this.state
  )
  return originalRegisterModule.call(this, path, rawModule, { preserveState, ...options })
}

async function createApp(ssrContext, config = {}) {
  const store = createStore(ssrContext)
  const router = await createRouter(ssrContext, config, { store })

  // Add this.$router into store actions/mutations
  store.$router = router

  // Fix SSR caveat https://github.com/nuxt/nuxt.js/issues/3757#issuecomment-414689141
  store.registerModule = registerModule

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"htmlAttrs":{"lang":"ru"},"meta":[{"charset":"UTF-8"},{"name":"theme-color","content":"ED2939"},{"name":"http-equiv=\"X-UA-Compatible","content":"ie=edge"},{"name":"viewport","content":"width=device-width, initial-scale=1"},{"name":"format-detection","content":"telephone=no"},{"name":"msapplication-TileColor","content":"#ffffff"},{"name":"theme-color","content":"#ffffff"},{"name":"apple-mobile-web-app-capable","content":"yes"},{"name":"apple-mobile-web-app-status-bar-style","content":"black-translucent"}],"link":[{"rel":"icon","href":"\u002Ffavicon.ico","sizes":"any"},{"rel":"icon","href":"\u002Ffavicon.svg","type":"image\u002Fsvg+xml"},{"rel":"mask-icon","href":"\u002Fmask-icon.svg","color":"#ED2939"},{"rel":"manifest","href":"\u002Fmanifest.json"},{"rel":"apple-touch-icon","href":"https:\u002F\u002Fautodrive.spb.ru\u002Fapple-touch-icon.png","type":"image\u002Fpng","sizes":"180x180"},{"rel":"apple-touch-icon","href":"\u002Fapple-touch-icon-512x512.png","type":"image\u002Fpng","sizes":"512x512"},{"rel":"apple-touch-icon","href":"\u002Fapple-touch-icon-120x120-precomposed.png","type":"image\u002Fpng","sizes":"120x120"},{"rel":"apple-touch-icon","href":"\u002Fapple-touch-icon-120x120.png","type":"image\u002Fpng","sizes":"120x120"}],"style":[],"script":[]},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      errPageReady: false,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        nuxt.errPageReady = false
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    beforeSerializeFns: ssrContext ? ssrContext.beforeSerializeFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_plugin_17181562 === 'function') {
    await nuxt_plugin_plugin_17181562(app.context, inject)
  }

  if (typeof nuxt_plugin_nuxtsvgsprite_5a70aed4 === 'function') {
    await nuxt_plugin_nuxtsvgsprite_5a70aed4(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_40b5c378 === 'function') {
    await nuxt_plugin_axios_40b5c378(app.context, inject)
  }

  if (typeof nuxt_plugin_deviceplugin_70ee6303 === 'function') {
    await nuxt_plugin_deviceplugin_70ee6303(app.context, inject)
  }

  if (typeof nuxt_plugin_apollomodule_78999744 === 'function') {
    await nuxt_plugin_apollomodule_78999744(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuescrollto_59c8eb91 === 'function') {
    await nuxt_plugin_vuescrollto_59c8eb91(app.context, inject)
  }

  if (typeof nuxt_plugin_lazySizes_2ffd0c20 === 'function') {
    await nuxt_plugin_lazySizes_2ffd0c20(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_rangeSlider_49b059af === 'function') {
    await nuxt_plugin_rangeSlider_49b059af(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_pagination_0c55d867 === 'function') {
    await nuxt_plugin_pagination_0c55d867(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_fancyappsui_7799b51b === 'function') {
    await nuxt_plugin_fancyappsui_7799b51b(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_infiniteLoading_36c8a665 === 'function') {
    await nuxt_plugin_infiniteLoading_36c8a665(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_numberAnim_732761f2 === 'function') {
    await nuxt_plugin_numberAnim_732761f2(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_ymaps_3e7212dd === 'function') {
    await nuxt_plugin_ymaps_3e7212dd(app.context, inject)
  }

  if (typeof nuxt_plugin_swiper_68e7f06e === 'function') {
    await nuxt_plugin_swiper_68e7f06e(app.context, inject)
  }

  if (typeof nuxt_plugin_inputmask_6c1106f7 === 'function') {
    await nuxt_plugin_inputmask_6c1106f7(app.context, inject)
  }

  if (typeof nuxt_plugin_slideToggle_24c04730 === 'function') {
    await nuxt_plugin_slideToggle_24c04730(app.context, inject)
  }

  if (typeof nuxt_plugin_lodash_5d4c7b8c === 'function') {
    await nuxt_plugin_lodash_5d4c7b8c(app.context, inject)
  }

  if (typeof nuxt_plugin_tippy_7d0eb109 === 'function') {
    await nuxt_plugin_tippy_7d0eb109(app.context, inject)
  }

  if (typeof nuxt_plugin_helpers_1c816d70 === 'function') {
    await nuxt_plugin_helpers_1c816d70(app.context, inject)
  }

  if (typeof nuxt_plugin_jsonld_593ee954 === 'function') {
    await nuxt_plugin_jsonld_593ee954(app.context, inject)
  }

  if (typeof nuxt_plugin_domain_d2923006 === 'function') {
    await nuxt_plugin_domain_d2923006(app.context, inject)
  }

  if (typeof nuxt_plugin_apiService_6b93a5b4 === 'function') {
    await nuxt_plugin_apiService_6b93a5b4(app.context, inject)
  }

  if (typeof nuxt_plugin_chart_48b5b2cf === 'function') {
    await nuxt_plugin_chart_48b5b2cf(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
